<template>
  <section class="py-12">
    <div class="container-wrap">
      <h2 class="text-h1 mb-6">{{ sectionData.name }}</h2>
      <ul class="column-321">
        <li v-for="item in sectionData.subSections" :key="hash(item)">
          <CardDocument
            :title="item.name || ''"
            :description="item.description || ''"
            :button-name="item.link?.name || ''"
            :button-url="item.link?.url"
          />
        </li>
      </ul>
    </div>
  </section>
</template>

<script setup lang="ts">
  import hash from 'object-hash';

  import type { ISection } from '@/assets/types/api/Pages';

  interface IProps {
    sectionData: ISection;
  }

  withDefaults(defineProps<IProps>(), {
    sectionData: () => ({
      code: null,
      name: null,
      description: null,
      type: 1,
      imageUrl: null,
      imageAlt: null,
      link: null,
      align: null,
      theme: null,
      subSections: [],
    }),
  });
</script>
